<ng-container *transloco="let t;">
    <app-detail-view [loading]="loading" [messages]="messages" [close]="false">

      <div title>
        <h1>
          <span>{{ t('common.labels.rights') }}</span>
        </h1>
    </div>

    <div details>
        <form novalidate (submit)="onSubmit()">
          <div class="p-grid">
            <div class="p-col-9 p-d-flex p-ai-center">
              <ng-container *ngIf="inEdit !== true">
                {{ t('common.labels.filter') }}:
                <input pInputText type="text" [(ngModel)]="search" [ngModelOptions]="{standalone: true}" [placeholder]="t('common.labels.rolename')" class="p-ml-2 p-mr-2"/>
                <p-checkbox label="{{ t('common.labels.custom') }}" [(ngModel)]="custom" [ngModelOptions]="{standalone: true}" [binary]="true"></p-checkbox>
              </ng-container>
            </div>
            <div class="p-col-3 p-text-right p-mb-4">
                <button *ngIf="inEdit !== true" pButton [label]="t('common.labels.edit')" (click)="onEdit()" class="p-button-sm"></button>
                <app-form-buttons *ngIf="inEdit === true" [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
            </div>
          </div>

            <ng-container *ngIf="rights !== null && roles !== null">
                <ng-container *ngFor="let mainGroup of rights">
                    <!-- <h2>{{ t('common.labels.' + mainGroup.name) }}</h2> -->

                    <p-table [value]="mainGroup.subGroups" [paginator]="false" [rows]="100000" rowGroupMode="subheader" groupRowsBy="name">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{ t('common.labels.right') }}</th>
                                <th *ngFor="let role of roles" [ngClass]="{hidden: isHidden(role)}">{{ role.translated_title }}</th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="groupheader" let-subGroup>
                            <tr pRowGroupHeader>
                                <td [attr.colspan]="roles.length + 1">
                                    <strong>{{ t('common.labels.' + subGroup.name)  }}</strong>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-subGroup>
                            <tr *ngFor="let right of subGroup.rights">
                                <td>{{ t('common.labels.' + right.label) }}</td>
                                <td *ngFor="let role of roles" [ngClass]="{hidden: isHidden(role)}">
                                    <p-checkbox [formControl]="right.controls[role.name]" (click)="onRightClicked(right, role, subGroup, right.controls[role.name])" binary="true"></p-checkbox>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                </ng-container>
            </ng-container>

        </form>

    </div>

    </app-detail-view>
</ng-container>
